<div class="mat-typography">
    <p>Removed AU data for Group Ids: {{ data.removeGroupIdsProcessed | number }}</p>
    <p>Added AU data for Group Ids: {{ data.addGroupIdsProcessed }}</p>
    <p>Processed Buildings: {{ data.buildingsProcessed | number }}</p>
    <p>Processed Allowed Uses: {{ data.usesHashesAdded | number }}</p>
    <p>Failed Remove AU data for Group Ids: {{ data.removeGroupIdsFailed | number }}</p>
    <p>Failed Added AU data for Group Ids: {{ data.addGroupIdsFailed | number }}</p>
    <p>Failed Allowed Uses: {{ data.usesHashesFailed | number }}</p>
    <p>Ignored Remove AU data for Group Ids: {{ data.removeGroupIdsIgnored | number }}</p>
    <p>Ignored Added AU data for Group Ids: {{ data.addGroupIdsIgnored | number }}</p>
    <p>Ignored Allowed Uses: {{ data.usesHashesIgnored | number }}</p>
    <p>Original Operations: {{ data.originalOperationsCount | number }}</p>
    <p>Accepted Operations: {{ data.acceptedOperationsCount | number }}</p>
    <p>Duplicate Operations: {{ data.duplicteOperationsCount | number }}</p>
    <p>Duplicated Operations Keys: {{ duplictedKeysStr }}</p>
    <p>PRs with invalid AU: {{ data.prsWithInvalidAUCount | number }}</p>
    <p>Invalid AUs: {{ data.invalidAUCount | number }}</p>
    <p>Unique invalid Calibration Uses Labels: {{ invalidCULsIdsCount }}</p>
    <p>Invalid Calibration Uses Labels Ids: {{ invalidCULsIdsStr }}</p>
</div>
